import type { NotifyPort } from '@/features/messages/domain/notify'
import type { WorkItem, WorkItemPort } from '../domain/workflow'

const listSpawns = async (
	port: WorkItemPort,
	parentId: string,
	notify: NotifyPort,
): Promise<WorkItem[]> => {
	try {
		return await port.listByParent(parentId)
	} catch {
		notify.error('workItem.derivedTasksLoadFailed')
		return []
	}
}

export { listSpawns }
